export const GA4_ID = "G-QLVKP7R6W7";
export const SUPPORT_EMAIL =
  "incoming+voellmy-chordpic-13938802-issue-@incoming.gitlab.com";
